<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfm" style="font-style: normal;"><a class="xref" href="#/chicresswell0006#acknow">ACKNOWLEDGMENTS</a></p>
<p class="toc"><a class="xref" href="#/chicresswell0008#pt01">PART ONE   Writing Place</a></p>
<p class="toc"><a class="xref" href="#/chicresswell0009#pt02">PART TWO   Market/Place</a></p>
<p class="toc"><a class="xref" href="#/chicresswell0011#pt03">PART THREE   Thinking Place</a></p>
<p class="tocbmf" style="font-style: normal;"><a class="xref" href="#/chicresswell0012#notes">NOTES</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chicresswell0013#biblio">BIBLIOGRAPHY</a></p>
<p class="tocbm" style="font-style: normal;"><a class="xref" href="#/chicresswell0014#index">INDEX</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-cresswell-0005.vue?f96a0f46